<script setup>
import { computed, nextTick, onMounted, watch } from 'vue'

const URL_PATTERN = /^https?:\/\/(?:www\.)?(?:x|twitter)\.com\/[A-Za-z0-9_]+\/status\/\d+/i

const props = defineProps({
	url: {
		type: String,
		default: null,
	},
})

const href = computed(() => {
	const value = (props.url || '').trim()

	return URL_PATTERN.test(value) ? value : null
})

function loadWidgetsScript() {
	if (window.twttr?.widgets) {
		return Promise.resolve(window.twttr)
	}

	if (window.__twitterWidgetsPromise) {
		return window.__twitterWidgetsPromise
	}

	window.__twitterWidgetsPromise = new Promise((resolve) => {
		const existing = document.getElementById('twitter-wjs')

		if (existing) {
			existing.addEventListener('load', () => resolve(window.twttr), { once: true })

			return
		}

		const script = document.createElement('script')
		script.id = 'twitter-wjs'
		script.src = 'https://platform.x.com/widgets.js'
		script.async = true
		script.onload = () => resolve(window.twttr)
		document.body.appendChild(script)
	})

	return window.__twitterWidgetsPromise
}

async function hydrateTweet() {
	if (!href.value) {
		return
	}

	await nextTick()
	const twttr = await loadWidgetsScript()
	twttr?.widgets?.load()
}

onMounted(hydrateTweet)
watch(() => props.url, hydrateTweet)
</script>

<template>
	<blockquote v-if="href" class="twitter-tweet">
		<a :href="href"></a>
	</blockquote>
</template>
